import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';

import pxToEm from 'styles/pxToEm';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  label: {
    display: 'block',
    position: 'relative',
    marginBottom: 0,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
    whiteSpace: 'nowrap',
  },
  typography: {
    display: 'block',
    padding: '4px 0',
    lineHeight: pxToEm(16, 14),
    minHeight: pxToEm(16, 14),
  },
});

const InventoryStockLineCreateEditTotalUnitsFields = ({ variant, classes, ...fields }) => {
  const quantity = get(fields, 'Boxes Quantity').input.value;
  const unitsInBox = get(fields, 'Units in Box').input.value;
  let totalUnits;
  if (variant === 'Kcal Units') {
    const kcalUnitsInItem = get(fields, 'Calories Per Unit').input.value;
    totalUnits = quantity && unitsInBox && kcalUnitsInItem
      ? Math.round((quantity * unitsInBox * kcalUnitsInItem) / 100) : null;
  } else {
    totalUnits = quantity && unitsInBox ? quantity * unitsInBox : null;
  }
  if (!totalUnits) {
    return '';
  }
  return (
    <Grid item>
      <InputLabel
        className={classes.label}
        disableAnimation
        shrink={false}
      >
        {variant === 'Kcal Units' ? 'Caloric Units:' : 'Total Units:'}
      </InputLabel>
      <Typography className={classes.typography}>
        {totalUnits}
      </Typography>
    </Grid>
  );
};

InventoryStockLineCreateEditTotalUnitsFields.propTypes = {
  variant: PropTypes.oneOf(['Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineCreateEditTotalUnitsFields.defaultProps = {
  variant: 'Boxes',
};

export default withStyles(styles)(InventoryStockLineCreateEditTotalUnitsFields);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditTotalUnitsFields.js